import Vue from 'vue'
import App from './App.vue'
import { Message, Dialog, Button, Option, OptionGroup, Form, FormItem, Input, Select, Table, TableColumn, Pagination, MessageBox, Loading, Cascader, Drawer } from 'element-ui'
import infiniteScroll from "vue-infinite-scroll";

Vue.use(infiniteScroll);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Cascader);
Vue.use(Drawer);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
const message = options => {
  return Message({
    showClose: true,
    ...options,
  });
};
['success', 'warning', 'info', 'error'].forEach(type => {
  message[type] = options => {
    if (typeof options === 'string') {
      options = { message: options };
    }
    return message({
      type,
      ...options,
    });
  };
});
Vue.prototype.$message = message;
// Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;

import './utils/preventReClick' // 按钮防重复提交

import router from './router'
import store from './store'

import './assets/style/index.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
